import React from 'react';
import styled from 'styled-components';
import DataEntryModal from '@grnhse/seedling/lib/birch/components/modals/data_entry_modal';
import { withLocalePrefix } from 'shared/utils/translation';
import { useUserContext, TABS } from 'talent_matching/contexts/user_context';
import { Document } from 'talent_matching/types';
import DocumentHeader from './document_header';
import DocumentContent from './document_content';
import { Person } from 'talent_matching/types';

const t = withLocalePrefix('talent_matching.document_viewer_modal');

const BodyContainer = styled.div`
  min-height: calc(100vh - 200px);
`;

export interface DocumentViewerModalProps {
  document: Document;
  onClose: () => void;
  openFeedbackModal: () => void;
  openRejectModal: () => void;
  application: Person;
  canAdvance: boolean;
  canReject: boolean;
  onAdvanceSuccess?: () => void;
  canDownloadCandidateData: boolean;
}

const DocumentViewerModal = ({
  document,
  onClose,
  openFeedbackModal,
  openRejectModal,
  canAdvance,
  canReject,
  canDownloadCandidateData,
  application,
  onAdvanceSuccess,
}: DocumentViewerModalProps) => {
  const { calibrationTerms, activeTab } = useUserContext();

  return (
    <DataEntryModal
      isOpen={true}
      onDismiss={onClose}
      ariaLabel={t('document_preview_for', { fileName: document.file_name })}
      size="extraLarge"
    >
      <DataEntryModal.Body>
        <DocumentHeader
          document={document}
          onClose={onClose}
          openRejectModal={openRejectModal}
          candidate={application}
          openFeedbackModal={openFeedbackModal}
          canAdvance={canAdvance}
          canReject={canReject}
          onAdvanceSuccess={onAdvanceSuccess}
          canDownloadCandidateData={canDownloadCandidateData}
          showCandidateActions={activeTab !== TABS.REDISCOVERY}
        />

        <BodyContainer>
          <DocumentContent
            document={document}
            hasCalibrationTerms={Boolean(calibrationTerms?.length)}
          />
        </BodyContainer>
      </DataEntryModal.Body>
    </DataEntryModal>
  );
};

export default DocumentViewerModal;
